export const questions = [
  {
    id: 1,
    text: "周末突然多出一整天空闲，你会？",
    color: "#4a3a6b",
    options: [
      { text: "规划好时间表，高效完成待办事项", archetype: "ruler", weight: 3 },
      { text: "尝试一直想学的新技能", archetype: "hero", weight: 3 },
      { text: "去没去过的地方探索", archetype: "explorer", weight: 3 },
      { text: "沉浸在自己的创作中", archetype: "creator", weight: 3 },
      { text: "约朋友出来聚聚", archetype: "lover", weight: 3 },
      { text: "在家躺平追剧放松", archetype: "everyman", weight: 3 },
    ],
  },
  {
    id: 2,
    text: "朋友遇到麻烦向你求助，你的第一反应？",
    color: "#3a4a6b",
    options: [
      { text: "冷静分析问题，给出解决方案", archetype: "sage", weight: 3 },
      { text: "立刻行动，帮TA解决", archetype: "hero", weight: 3 },
      { text: "先安慰情绪，陪伴倾听", archetype: "caregiver", weight: 3 },
      { text: "感同身受，给予情感支持", archetype: "lover", weight: 3 },
      { text: "用幽默化解紧张气氛", archetype: "jester", weight: 3 },
      { text: "相信TA能自己解决，给予鼓励", archetype: "innocent", weight: 3 },
    ],
  },
  {
    id: 3,
    text: "面对一个不合理的规则，你会？",
    color: "#6b3a3a",
    options: [
      { text: "公开质疑并推动改变", archetype: "outlaw", weight: 3 },
      { text: "研究规则漏洞，找到变通方法", archetype: "sage", weight: 3 },
      { text: "用创意方式绕过它", archetype: "magician", weight: 3 },
      { text: "先遵守，私下寻求改进", archetype: "ruler", weight: 3 },
      { text: "随大流，不想惹麻烦", archetype: "everyman", weight: 3 },
      { text: "相信规则存在自有道理", archetype: "innocent", weight: 3 },
    ],
  },
  {
    id: 4,
    text: "你最享受的成就感来源是？",
    color: "#4a5a4a",
    options: [
      { text: "带领团队达成目标", archetype: "ruler", weight: 3 },
      { text: "克服困难完成挑战", archetype: "hero", weight: 3 },
      { text: "创造出独一无二的作品", archetype: "creator", weight: 3 },
      { text: "帮助他人解决问题", archetype: "caregiver", weight: 3 },
      { text: "发现新知识或新观点", archetype: "sage", weight: 3 },
      { text: "让身边的人开心", archetype: "jester", weight: 3 },
    ],
  },
  {
    id: 5,
    text: "在社交场合中，你通常是？",
    color: "#5a3a5a",
    options: [
      { text: "主导话题和节奏的人", archetype: "ruler", weight: 3 },
      { text: "活跃气氛的开心果", archetype: "jester", weight: 3 },
      { text: "认真倾听的那个人", archetype: "caregiver", weight: 3 },
      { text: "和每个人都能聊得来", archetype: "everyman", weight: 3 },
      { text: "更喜欢一对一深聊", archetype: "lover", weight: 3 },
      { text: "观察人群，思考人性", archetype: "sage", weight: 3 },
    ],
  },
  {
    id: 6,
    text: "如果可以拥有一种超能力？",
    color: "#3a5a6b",
    options: [
      { text: "瞬间移动，去任何想去的地方", archetype: "explorer", weight: 3 },
      { text: "读心术，理解他人内心", archetype: "lover", weight: 3 },
      { text: "时间控制，掌控一切", archetype: "ruler", weight: 3 },
      { text: "创造幻象，把想象变成现实", archetype: "magician", weight: 3 },
      { text: "治愈能力，帮助所有人", archetype: "caregiver", weight: 3 },
      { text: "无敌力量，保护重要的人", archetype: "hero", weight: 3 },
    ],
  },
  {
    id: 7,
    text: "你最难以忍受的是？",
    color: "#4a4a6b",
    options: [
      { text: "被束缚在条条框框里", archetype: "outlaw", weight: 3 },
      { text: "一成不变的重复生活", archetype: "explorer", weight: 3 },
      { text: "无法理解事物的本质", archetype: "sage", weight: 3 },
      { text: "身边没有亲密的人", archetype: "lover", weight: 3 },
      { text: "努力却得不到认可", archetype: "hero", weight: 3 },
      { text: "看到不公平的事情", archetype: "outlaw", weight: 2 },
    ],
  },
  {
    id: 8,
    text: "别人对你最常见的评价是？",
    color: "#6b4a3a",
    options: [
      { text: "靠谱、有领导力", archetype: "ruler", weight: 3 },
      { text: "有趣、脑洞大", archetype: "jester", weight: 3 },
      { text: "温暖、善解人意", archetype: "caregiver", weight: 3 },
      { text: "独特、有创意", archetype: "creator", weight: 3 },
      { text: "真诚、容易相处", archetype: "everyman", weight: 3 },
      { text: "神秘、难以捉摸", archetype: "magician", weight: 3 },
    ],
  },
  {
    id: 9,
    text: "面对未知的未来，你的态度是？",
    color: "#5a4a5a",
    options: [
      { text: "充满期待，迫不及待想探索", archetype: "explorer", weight: 3 },
      { text: "相信一切都会好起来", archetype: "innocent", weight: 3 },
      { text: "做好规划，掌控风险", archetype: "ruler", weight: 3 },
      { text: "用想象力创造可能性", archetype: "magician", weight: 3 },
      { text: "无论如何都要勇敢面对", archetype: "hero", weight: 3 },
      { text: "顺其自然，随遇而安", archetype: "everyman", weight: 3 },
    ],
  },
  {
    id: 10,
    text: "你认为人生最重要的是？",
    color: "#3a3a5a",
    options: [
      { text: "追求真理和智慧", archetype: "sage", weight: 3 },
      { text: "创造有意义的作品", archetype: "creator", weight: 3 },
      { text: "拥有深刻的情感连接", archetype: "lover", weight: 3 },
      { text: "保持纯真和快乐", archetype: "innocent", weight: 3 },
      { text: "打破常规，活出自我", archetype: "outlaw", weight: 3 },
      { text: "体验丰富多彩的人生", archetype: "explorer", weight: 3 },
    ],
  },
];
